import React, { Component } from "react";
import { Wrapper, Title, Copy } from "app/NativeComponents/common";

class PartnerStat extends Component {
  render() {
    return (
      <Wrapper
        style={{
          flex: 1,
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Title
          style={{
            textAlign: "center",
            fontSize: 34,
            lineHeight: this.props.device == "desktop" ? "46px" : 46,
            color: this.props.colors.active_color
          }}
        >
          {this.props.number}
        </Title>
        <Copy
          style={{
            textAlign: "center"
          }}
        >
          {this.props.text}
        </Copy>
      </Wrapper>
    );
  }
}

export default PartnerStat;
